import React from 'react';
import { LegalText } from 'anf-core-react';
import TmntHtml from '../../tools/TmntHtml';

export default function ReviewsLegalText({
  tmntData,
  customerServiceUrl,
}) {
  const legalTextRaw = tmntData?.reviewsLegalText?.value;
  const legalTextWithLink = legalTextRaw?.replace('{0}', customerServiceUrl);

  return (
    <div
      className="reviews-legal-text"
      data-testid="reviews-legal-text"
    >
      <LegalText>
        <TmntHtml value={legalTextWithLink} />
      </LegalText>
    </div>
  );
}
